/* =====================================================================
   MATERIAL DEFINITIONS
   Each material has a physical side (density, friction, bounciness)
   and a visual side (a procedurally drawn texture).
   ===================================================================== */

export type Size = [number, number, number];

export interface MaterialDef {
  id: string;
  name: string;
  trait: string;
  density: number;
  friction: number;
  restitution: number;
  color: string;
  rough: number;
  metal: number;
  opacity?: number;
}

export interface Shape {
  id: string;
  name: string;
  size: Size;
}

// prettier-ignore
export const MATERIAL_DEFS: MaterialDef[] = [
  { id: 'wood',   name: 'Wood',   trait: 'Balanced and dependable',  density: 0.7,  friction: 0.5,  restitution: 0.1,  color: '#c58b4e', rough: 0.8,  metal: 0 },
  { id: 'stone',  name: 'Stone',  trait: 'Heavy and grippy',         density: 2.2,  friction: 0.75, restitution: 0.03, color: '#8f9399', rough: 0.95, metal: 0 },
  { id: 'ice',    name: 'Ice',    trait: 'Slides on almost anything', density: 0.9,  friction: 0.02, restitution: 0.05, color: '#bfe6f5', rough: 0.1,  metal: 0, opacity: 0.78 },
  { id: 'rubber', name: 'Rubber', trait: 'Grippy and bouncy',        density: 1.1,  friction: 1.0,  restitution: 0.96, color: '#d6453d', rough: 0.9,  metal: 0 },
  { id: 'metal',  name: 'Metal',  trait: 'Very heavy, a bit slick',  density: 4.0,  friction: 0.3,  restitution: 0.15, color: '#b9c0c8', rough: 0.35, metal: 0.7 },
  { id: 'foam',   name: 'Foam',   trait: 'Feather light',            density: 0.15, friction: 0.6,  restitution: 0.4,  color: '#f2d65c', rough: 1.0,  metal: 0 },
];

// prettier-ignore
export const SHAPES: Shape[] = [
  { id: 'cube',   name: 'Cube',   size: [1, 1, 1] },
  { id: 'plank',  name: 'Plank',  size: [3, 0.35, 0.9] },
  { id: 'pillar', name: 'Pillar', size: [0.6, 2, 0.6] },
  { id: 'slab',   name: 'Slab',   size: [2, 0.5, 2] },
];
